import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/blog/qbd-acquires-azierta")({
  head: () => buildRouteHead("/blog/qbd-acquires-azierta", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/en/news", replace: true });
  },
});
